<template>
    <div>
        {{ msg }}
    </div>
</template>

<script>
export default {
    name: "PurchaseReturns",
    data() {
        return {
            msg: 'Purchae Returns here',
        }
    },
}
</script>

<style scoped>

</style>
